<generic-incident-modal [parent]="this" [busy]="busy">
    <ng-container header>
        <button class="icon--copy btn--default" type="button" href="javascript:void(0);" (click)="getLatestIncident()" *ngIf="!data.isReadOnly && (0 == data.incident.incidentNumberId) && (true == canGetLatest)">
            Copy Last Conviction
        </button>
    </ng-container>
    <form [formGroup]="form">
        <h2>Driver License Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-md-4 mvd_form-group">
                    <label>Driver License Number</label>
                    <input class="mvd_form-control" type="text" formControlName="driverLicenseNumber" />
                </div>
                <div class="col-md-6 mvd_form-group">
                    <label>Driver License Jurisdiction</label>
                    <select class="mvd_form-control" formControlName="driverLicenseJurisdictionId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let j of jurisdictions" [value]="j.value">{{ j.text }}</option>
                    </select>
                </div>
            </div>
        </fieldset>
        <h2>Registration Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-md-3 mvd_form-group">
                    <label>Vehicle Plate Number</label>
                    <input class="mvd_form-control" formControlName="vehicleLicensePlateNumber" />
                </div>
                <div class="col-md-3 mvd_form-group">
                    <label>Vehicle Plate Type</label>
                    <select class="mvd_form-control" formControlName="plateTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let i of plateTypes" [value]="i.value">{{ i.text }}</option>
                    </select>
                </div>
                <div class="col-md-3 mvd_form-group">
                    <label>Vehicle Plate Jurisdiction</label>
                    <select class="mvd_form-control" formControlName="vehicleRegistrationJurisdictionId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let i of jurisdictions" [value]="i.value">{{ i.text }}</option>
                    </select>
                </div>
                <div class="col-md-3 mvd_form-group">
                    <label>Vehicle Make</label>
                    <input type="text" class="mvd_form-control" formControlName="vehicleMake" />
                </div>
            </div>
        </fieldset>
        <h2>Court Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Court Number</label>
                    <select class="mvd_form-control" formControlName="courtId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let court of courts" [value]="court.id">{{ court.displayName }}</option>
                    </select>
                    <control-validation-messages control="courtId"></control-validation-messages>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Court Type</label>
                    <div class="mvd_form-control">{{ selectedCourt?.courtTypeDisplayValue}}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>Court Phone Number</label>
                    <div class="mvd_form-control">{{ selectedCourt?.phone | phoneNumberUSA }}</div>
                </div>
                <div class="col-sm-9 mvd_form-group">
                    <label>Court Address</label>
                    <div class="mvd_form-control">{{ selectedCourt?.addressLine1 }}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label>Court City</label>
                    <div class="mvd_form-control">{{ selectedCourt?.city }}</div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Court State</label>
                    <div class="mvd_form-control">{{ selectedCourt?.jurisdictionDisplayValue }}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Court Zipcode</label>
                    <div class="mvd_form-control">{{ selectedCourt?.postalZipCode }}</div>
                </div>
            </div>
        </fieldset>
        <h2>Incident Details</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Citing Agency</label>
                    <select class="mvd_form-control" formControlName="citingAgencyTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let item of citingAgencyTypes" [value]="item.value">{{ item.text }}</option>
                    </select>
                    <control-validation-messages control="citingAgencyTypeId"></control-validation-messages>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label [ngClass]="{ 'required': speedRequired }" [attr.title]="speedRequired ? '* Required' : null">Approximate Speed</label>
                    <input type="text" class="mvd_form-control" formControlName="approximateSpeed" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label [ngClass]="{ 'required': speedRequired }" [attr.title]="speedRequired ? '* Required' : null">Lawful Speed</label>
                    <input type="text" class="mvd_form-control" formControlName="lawfulSpeed" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Offense Classification</label>
                    <select class="mvd_form-control" formControlName="offenseClassificationTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let item of offenseClassificationTypes" [value]="item.value">{{ item.text }}</option>
                    </select>
                    <control-validation-messages control="offenseClassificationTypeId"></control-validation-messages>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Accident Indicator</label>
                    <select class="mvd_form-control" formControlName="accidentTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of accidentTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>CDL Holder</label>
                    <input type="checkbox" formControlName="isCDLHolder" />
                </div>
            </div>
        </fieldset>
        <h2>Charge Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Complaint Number</label>
                    <input type="text" formControlName="complaintNumber" class="mvd_form-control" />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Complaint Sequence #</label>
                    <input type="text" formControlName="complaintSequenceNumber" class="mvd_form-control" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required">Disposition Date</label>
                    <max-calendar [showIcon]="true"
                                formControlName="dispositionDate"
                                yearNavigator="true"
                                [yearRange]="yearRange">
                    </max-calendar>
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Court Disposition Code</label>
                    <select formControlName="courtDispositionCodeTypeId" class="mvd_form-control">
                        <option [ngValue]="null">- Select -</option>
                        <option *ngFor="let i of courtDispositionCodeTypes" [ngValue]="i.value">{{ i.text }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required">Conviction Date</label>
                    <max-calendar [showIcon]="true"
                                formControlName="convictionDate"
                                yearNavigator="true"
                                [yearRange]="yearRange">
                    </max-calendar>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Drugs Involved</label>
                    <select class="mvd_form-control" formControlName="drugViolationTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let i of drugViolationTypeTypes" [value]="i.value">{{ i.text }}</option>
                    </select>
                </div>
            </div>
            <h3 class="divider">Violation Circumstances</h3>
            <div class="row">
                <div class="col-md-6 mvd_form-group">
                    <label>Violation Occurred in Commercial Vehicle</label>
                    <input type="checkbox" formControlName="commercialMotorVehicleIndicator" />
                </div>
                <div class="col-md-6 mvd_form-group">
                    <label>Violation Occurred While Transporting Hazardous Materials</label>
                    <input type="checkbox" formControlName="hazardousMaterialIndicator" />
                </div>
                <div class="col-md-6 mvd_form-group">
                    <label>Violation Occurred While Transporting 16 or More Passengers</label>
                    <input type="checkbox" formControlName="passengerIndicator" />
                </div>
                <div class="col-md-6 mvd_form-group">
                    <label>Alternative Service Process Indicator</label>
                    <input type="checkbox" formControlName="alternativeServiceProcessIndicator" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mvd_form-group">
                    <label>Violation Occurred while Operating a VFH or as a TNC Driver</label>
                    <input type="checkbox" formControlName="operatingHireFlag" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label [ngClass]="{ 'required': underlyingViolationCodeRequired }" [attr.title]="underlyingViolationCodeRequired ? '* Required' : null">Underlying Violation Code</label>
                    <select class="mvd_form-control" formControlName="underlyingViolationCode">
                        <option [ngValue]="null">- Select -</option>
                        <option *ngFor="let t of convictionViolationCodes" [ngValue]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Underlying ACD Code</label>
                    <div class="mvd_form-control">{{ acdDisplay }}</div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>IID Additional Months</label>
                    <select class="mvd_form-control" formControlName="courtOrderedInterlockMonthsTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of courtOrderedInterlockMonths" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
            </div>
        </fieldset>
        <h2>Court Ordered Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Court Action Code</label>
                    <select class="mvd_form-control" formControlName="courtActionCodeTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of courtActionCodeTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Court Ordered Action Code</label>
                    <select class="mvd_form-control" formControlName="courtOrderedActionTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of courtOrderedActionTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Sentencing Authority</label>
                    <select class="mvd_form-control" formControlName="sentencingAuthorityNameId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let option of sentencingAuthorities" [value]="option.value">{{ option.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Alcohol Class Required</label>
                    <input type="checkbox" formControlName="alcoholClassReqCheck" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Withdrawal Beginning Date</label>
                    <max-calendar [showIcon]="true" formControlName="withdrawalBeginningActionDate" yearNavigator="true"></max-calendar>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Withdrawal Ending Date</label>
                    <max-calendar [showIcon]="true" formControlName="withdrawalEndingActionDate" yearNavigator="true"></max-calendar>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Withdrawal # of Mos/Yrs</label>
                    <input type="number" formControlName="withdrawalNumberOfMonths" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Restriction Beginning Date</label>
                    <max-calendar [showIcon]="true" formControlName="restrictionBeginningActionDate" yearNavigator="true"></max-calendar>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Restriction Ending Date</label>
                    <max-calendar [showIcon]="true" formControlName="restrictionEndingActionDate" yearNavigator="true"></max-calendar>
                </div>
            </div>
        </fieldset>
    </form>
</generic-incident-modal>